import { useEffect, useState } from "react";
import { SplitShell } from "./ctui/SplitShell";
import { BootSequence } from "./effects/BootSequence";
import { MatrixRain } from "./effects/MatrixRain";
import { useThemeBootstrap } from "./state/theme";

type Phase = "boot" | "ready";

const BOOT_STORAGE_KEY = "ripper.bootSeen";

export function App() {
  useThemeBootstrap();
  const [phase, setPhase] = useState<Phase>(() => {
    // Replay boot once per session — useful for live demos. Comment out to always show.
    return sessionStorage.getItem(BOOT_STORAGE_KEY) === "1" ? "ready" : "boot";
  });

  useEffect(() => {
    if (phase === "ready") sessionStorage.setItem(BOOT_STORAGE_KEY, "1");
  }, [phase]);

  if (phase === "boot") {
    return <BootSequence onComplete={() => setPhase("ready")} />;
  }

  return (
    <>
      <MatrixRain opacity={0.035} layer="bg" />
      <SplitShell />
    </>
  );
}
